import { angular, app } from '../../app.module'
app
  // 一括タグ編集ボックス
  .directive('batchTagChips', () => {
    return {
      restrict: 'E',
      // 親スコープから分離し、属性から値を取得
      scope: {
        tagType: '@tagType',
        tagRole: '@tagRole',
        snsType: '@snsType',
        selectedIds: '=selectedIds',
      },
      template: require('./batch-tag-chips.pug')(),
      controller: ($rootScope, $scope, TagChipsService, $element) => {
        // タグの種類(投稿タグorアカウントタグ)
        const tagType: string = $scope.tagType
        // タグの役割(グローバル、グループ、ユーザー)
        const tagRole: string = $scope.tagRole
        // SNSの種類(facebook, twitter等)
        const snsType: string = $scope.snsType
        // タグをつける対象のID(FB投稿ID, TWアカウントID等)
        const selectedIds: [string] = $scope.selectedIds
        // 所属するグループID
        const groupId: number = $rootScope.groupId
        // ユーザーID
        const userId: number = $rootScope.userId

        // タグを初期化
        $scope.tags = []

        // サジェスト用にグループ内のタグを取得
        TagChipsService.Common.getAllTags(tagType, tagRole, snsType, groupId, userId).then(
          (allTags: {}[]) => {
            if (allTags !== null) {
              $scope.autoCompleteTags = allTags
              TagChipsService.Common.getAllTagMap(
                tagType,
                tagRole,
                snsType,
                groupId,
                userId,
                selectedIds
              ).then((targetsTags) => {
                if (targetsTags.length === 0) {
                  $scope.tags = []
                  return
                }

                let commonTags = targetsTags.pop()
                for (const tags of targetsTags) {
                  for (const commonTag of commonTags) {
                    if (tags.every((tag) => tag.tagId !== commonTag.tagId)) {
                      commonTags = commonTags.filter((tag) => tag.tagId !== commonTag.tagId)
                    }
                  }
                }

                $scope.tags = commonTags.map((tag) => {
                  return {
                    tagId: tag.tagId,
                    tagName: tag.tagName,
                    tagRole: tagRole,
                  }
                })

                // すでに追加済みのタグについてはサジェストに表示しない
                $scope.tags.forEach((tag: { tagId: number }) => {
                  $scope.autoCompleteTags = $scope.autoCompleteTags.filter(
                    (suggestTag: { tagId: number }) => {
                      return tag.tagId !== suggestTag.tagId
                    }
                  )
                })
              })
            } else {
              // サジェストタグが何もない場合は、空の配列を作成
              $scope.autoCompleteTags = []
            }
          }
        )

        // タグをフィルタリングする処理
        function createFilterFor(query) {
          return function filterFn(tag) {
            // 大文字小文字を区別せずにオートコンプリートを動作させるため、検索クエリと検索対象を小文字に変換する
            const lowerCaseQuery = query.toLowerCase()
            const lowerCaseTagName = tag.tagName.toLowerCase()

            return lowerCaseTagName.indexOf(lowerCaseQuery) === 0
          }
        }

        // タグ入力欄がクリック、または文字列が入力された際の処理
        $scope.querySearch = function (query, selectedItem) {
          // 文字列が入力されていない場合は、全てのタグを表示する
          if (query === '' && selectedItem === null) {
            return $scope.autoCompleteTags
          } else if (query === '' && selectedItem !== null) {
            // 追加したタグがサジェストにあった場合は削除する
            return $scope.autoCompleteTags.filter((suggestTag) => {
              return selectedItem.tagName !== suggestTag.tagName
            })
          } else {
            // タグ入力欄に文字列が入力された場合は、マッチするタグを表示する
            return $scope.autoCompleteTags.filter(createFilterFor(query))
          }
        }

        // タグが追加された際の処理
        $scope.addTag = function (tagName) {
          // サーバーへPOSTする
          TagChipsService.Common.addTagByBatch(
            tagType,
            tagRole,
            snsType,
            groupId,
            userId,
            selectedIds,
            tagName
          ).then((result: { tagId: number }) => {
            // 新規追加したタグに、 タグIDを付与する
            const lastTag = $scope.tags.length - 1

            $scope.tags[lastTag].tagId = result.tagId

            // 追加したタグがサジェストにあった場合は削除する
            $scope.autoCompleteTags = $scope.autoCompleteTags.filter(
              (suggestTag: { tagName: string }) => {
                return tagName !== suggestTag.tagName
              }
            )
          })
        }

        // タグが削除された際の処理
        $scope.removeTag = function (tagId: number, tagName: string, tagCount: number) {
          // サーバーへPOSTする
          TagChipsService.Common.deleteTag(tagType, tagRole, snsType, selectedIds, tagId).then()

          // 新規追加したタグを、モーダルを閉じずに削除する場合は、タグカウント数に0を挿入
          if (tagCount === undefined) {
            tagCount = 0
          }

          // 削除したタグをサジェストに追加する
          $scope.autoCompleteTags.push({
            tagId: tagId,
            tagName: tagName,
            tagCount: tagCount,
          })

          // サジェストが一つある場合、md-autocompleteのコントローラのバリューをアップデート
          if ($scope.autoCompleteTags.length === 1) {
            const autoCompleteCtrl = $element
              .find('md-autocomplete-wrap')
              .scope().$mdAutocompleteCtrl

            // サジェスト一覧
            autoCompleteCtrl.matches = $scope.autoCompleteTags
            // サジェストを表示するフラグ
            autoCompleteCtrl.hidden = false
          }
        }

        // 新規追加されたタグを、オブジェクトに格納し、重複のチェックを行う
        $scope.transform = function (chip) {
          let newTag

          // 新規作成したタグは、オブジェクトに格納する
          if (angular.isObject(chip) === false) {
            newTag = {
              tagName: chip,
            }
          } else {
            newTag = chip
          }
          // 重複のチェックを行う
          return TagChipsService.Common.checkTagExist(newTag, $scope.tags)
        }
      },
    }
  })
